import utility from './utility'
//import Flickity from "flickity";

const cardFlip = {
	init: function() {
		const _this = this

		const cardFlips = [...document.querySelectorAll('.flip-trigger')]

		cardFlips.map(cardFlip => {
			cardFlip.onclick = () => {
				const lotteryCard = utility.findAncestor(cardFlip, 'lottery-card-flip')
					const cardHeight = lotteryCard.offsetHeight

				utility.toggleClass(lotteryCard, 'flip')

				if (lotteryCard.classList.contains('flip')) {
					utility.removeClass(lotteryCard, 'flip-front')
				} else {
					utility.addClass(lotteryCard, 'flip-front')
				}

				if (cardFlip.classList.contains('flip-stretch')) {
					lotteryCard.querySelector('.flipper').style.minHeight = `${cardHeight}px`
				}

				cardFlip.style.opacity = 0
				cardFlip.style.visibility = 'hidden'

				setTimeout(() => {
					cardFlip.style.opacity = 1
					cardFlip.style.visibility = 'visible'
				}, 200)
			}
		})
	},
}

export default cardFlip


// WEBPACK FOOTER //
// ./assets/src/js/classes/lotteryCard.js